import { Link } from 'react-router-dom';

import Typography from '~/shared/components/Typography';
import LinkIcon from '~/shared/assets/icons/link.svg';

export default function VolumeIdCell({ id }: { id: string }) {
  return (
    <Link to={`/fleet-manager/${id}`} className="flex items-center justify-between w-full">
      <Typography
        color="text-primary-500"
        variant="p3"
        fontWeight={700}
        className="font-family-inter cursor-pointer"
      >
        {id}
      </Typography>
      <LinkIcon className="size-5" />
    </Link>
  );
}
